/******************************************************************************************
 *  Storage Available Decider - true if both local and session storage available
 *******************************************************************************************
 *
 *
 */
(function() {
  

  angular.module('rcServices.storageAvailable', []).constant(
    'STORAGE_AVAILABLE',
    (function() {
      // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
      var storageAvailabe = function(type) {
        try {
          var storage = window[type];
          var x = '__storage_test__';
          storage.setItem(x, x);
          storage.removeItem(x);
          return true;
        } catch (e) {
          return false;
        }
      };

      return storageAvailabe('localStorage') && storageAvailabe('sessionStorage');
    })()
  );
})();
